import { axiosInstanceV1, withToken } from "@rentablo/api";
import { UserAuthorization } from "@rentablo/api/apiv1";

export const getMyAuthorization = async (token: string | undefined) => {
  const { data } = await axiosInstanceV1.get<UserAuthorization>(
    `/authorizations`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return data;
};

export const getMyAuthorizationWithToken = withToken(getMyAuthorization);
